<template>
    <div style="padding:20px;padding-bottom: 100px;text-align: left;">
        <div style="padding:20px;background: #fff;">
            <div style="font-weight: 600;display: flex;justify-content: space-between;">
               <span>协作编辑图片</span>
                <a :href="'/xiezuoupload?key='+secretkey"><el-button size="small" style="border-radius: 4px;" type="primary">去续传<i class="el-icon-right"></i></el-button></a>
            </div>
            <div style="margin:20px 0px;font-size: 20px;font-weight: 600;color:#000">
                {{ zuzhaotitle + '（' + zuzhaoobj.zhangshu + '/' + zuzhaoobj.xianshizhaopianshu + '）' }}
            </div>
            <div style="margin-left: 5px;font-size: 14px;margin-bottom: 5px;color:#999999"
                v-if="zuzhaoobj.shipinzongshu > 0">
                视频
            </div>
            <div v-if="shipinloading" style="text-align: center;font-weight: 600;">加载中...</div>
            <div style="display: flex;flex-wrap: wrap;">
                <div style="width:200px;height:240px;margin:5px;border: 1px solid #cccccc;background: #fff;box-shadow: 0 2px 12px 0 rgba(0,0,0,.3);"
                    v-for="(item, index) in shipinlist" :key="Number(item.id)">
                    <div style="width:190px;height: 130px;margin:5px;position: relative;border-bottom: 1px solid #aaaaaa;">
                        <img :src="item.cover_url" style="width: 100%;height: 100%;object-fit: contain;" />
                        <img src="../../assets/bofang.svg" @click="showshipinyulan(index)"
                            style="width:30px;cursor: pointer;top:50%;left:50%;height:30px;position: absolute;transform:translate(-50%, -50%)" />
                    </div>
                    <div style="font-size: 12px;padding:5px;line-height: 25px;">
                        <div>视频ID <span style="color:#aaaaaa">{{ item.id }}</span></div>
                        <div class="swcla" style="display: flex;justify-content: space-between;align-items: center;"><span
                                style="display: flex;align-items: center;">前台显示<el-switch style="margin-left: 5px;"
                                    @change="gengxinshipinxinxi(item, 1)" v-model="item.is_show" active-color="#ec652c"
                                    inactive-color="#cccccc" :active-value="1" :inactive-value="2" size="mini">
                                </el-switch></span>
                            <span style="color:#aaaaaa">{{ (item.file_size / 1024 / 1024).toFixed(2) }}MB</span>
                        </div>
                        <div style="display: flex;justify-content: space-between;">
                            <div style="width: 48%;">
                                <el-button size="small" style="width: 100%;"
                                    @click="gengxinshipinxinxi(item, 2)">置顶</el-button>
                            </div>
                            <div style="width: 48%;">
                                <el-button size="small" style="width: 100%;" @click="downloadshipin(item)"
                                    :loading="item.loading">下载视频</el-button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <hr v-if="zuzhaoobj.shipinzongshu > 0" style="margin-top:10px;border:1px solid #cccccc;">
            <div style="margin-left: 5px;font-size: 14px;margin-bottom: 5px;color:#999999">
                图片
            </div>
            <div style="">
                <div style="display: flex;flex-wrap: wrap;" :infinite-scroll-distance="1000" v-infinite-scroll="load"
                    :infinite-scroll-delay="100">
                    <div style="width:200px;height:320px;margin:5px;border: 1px solid #cccccc;background: #fff;box-shadow: 0 2px 12px 0 rgba(0,0,0,.3);"
                        v-for="(item, index) in showphotolist" :key="Number(item.id)">
                        <div style="width:190px;height: 130px;margin:5px;cursor: pointer;position: relative;border-bottom: 1px solid #aaaaaa;"
                            @click="showtupianyulan(index)">
                            <img v-if="item['300_path'] != null" :src="item['300_path']"
                                style="width: 100%;height: 100%;object-fit: contain;" />
                            <img v-else :src='IMAGEPATH + item.key.slice(0, 15) + "_300small" + item.key.slice(15)'
                                style="width: 100%;height: 100%;object-fit: contain;" />
                            <img v-if="('https://resources.luchuaner.com/' + zuzhaoobj.cover_path) == item['600_path']"
                                src="../../assets/fengmian.svg"
                                style="width:40px;height: 40px;position: absolute;top: -5px;right: -5px;" />
                            <img v-if="item.key != null && ('https://resources.luchuaner.com/' + zuzhaoobj.cover_path) == (IMAGEPATH + item.key.slice(0, 15) + '_300small' + item.key.slice(15))"
                                src="../../assets/fengmian.svg"
                                style="width:40px;height: 40px;position: absolute;top: -5px;right: -5px;" />
                        </div>
                        <div style="font-size: 12px;padding:5px;line-height: 25px;">
                            <div>图片ID <span style="color:#aaaaaa">{{ item.id }}</span></div>
                            <div class="swcla" style="display: flex;justify-content: space-between;align-items: center;">
                                <span style="display: flex;align-items: center;">前台显示<el-switch style="margin-left: 5px;"
                                        v-model="item.is_show" active-color="#ec652c" inactive-color="#cccccc"
                                        :active-value="1" :inactive-value="2" size="mini"
                                        @change="gengxintupianxinxi(item, 1)">
                                    </el-switch></span>
                                <span style="color:#aaaaaa">{{ (item.file_size / 1024 / 1024).toFixed(2) }}MB</span>
                            </div>
                            <div style="display: flex;justify-content: space-between;margin-top: 5px;">
                                <danzhangtihuan :type="1" :tihuanitem="item" :gengxintupianxinxi="gengxintupianxinxi" />
                                <el-button size="mini" style="padding:8px 15px"
                                    @click="gengxintupianxinxi(item, 2)">置顶</el-button>
                                <el-button size="mini" style="padding:8px 15px" @click="downloadImage(item)">大图</el-button>
                            </div>
                            <div class="xtbqdiv">
                                <el-button v-show="item.iscover != 1" size="mini" style="width:100%;margin-top: 10px;"
                                    @click="gengxintupianxinxi(item, 3)">设为封面</el-button>
                                <el-button v-show="item.iscover == 1" :disabled="true" size="mini"
                                    style="width:100%;margin:0px;margin-top: 10px;">封面图</el-button>
                                <el-select v-if="biaoqianlist.length > 0" size="mini" v-model="item.share_label_id" multiple
                                    style="width:100%;margin-top: 10px;" @change="gengxintupianxinxi(item, 4)"
                                    placeholder="选择标签">
                                    <el-option v-for="item in biaoqianlist" :key="item.id" :label="item.labelname"
                                        :value="item.id + ''">
                                    </el-option>
                                </el-select>
                                <a :href="'/zuzhao/upload?key=' + secretkey" v-else><el-button size="mini"
                                        style="width:100%;margin:0px;margin-top: 10px;">新增标签</el-button></a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div v-if="loading" style="text-align: center;font-weight: 600;margin:20px 0px">加载中...</div>
            <div v-if="showphotolist.length == photolist.length" style="text-align: center;"><el-divider
                    style="font-weight: 600;margin:20px 0px">没有更多了</el-divider></div>
            <el-dialog class="spyldiv1" :close-on-click-modal="false" :visible.sync="shipinVisible" width="1200px"
                :show-close="false" :before-close="handleClose">
                <img src="../../assets/guanbi.svg"
                    style="position: absolute;right: 10px;top:10px;width:30px;cursor: pointer;" @click="handleClose" />
                <div :key="timetemp" style="display: flex;">
                    <div style="width:900px;height:600px;background:#999999;" class="ylspcla">
                        <el-carousel :loop="false" @change="qihuanshipin" indicator-position="none"
                            :initial-index="initialindex" :autoplay="false" arrow="always" style="height: 100%;">
                            <el-carousel-item v-for="(item, index) in shipinyuanshilist" :key="item.id"
                                style="height: 100%;display: flex;align-items: center;">
                                <video v-if="index == initialindex" style="width:100%;" controls>
                                    <source :src="item.play_url" type="video/mp4">
                                </video>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                    <div
                        style="width:300px;height:520px;background: #999999;border-left: 1px solid #cccccc;text-align: center;display: flex;flex-direction: column;justify-content: space-between;padding-bottom: 80px;">

                        <div>
                            <div
                                style="text-align: center;font-size:28px;color: #000000;border-bottom: 1px solid #cccccc;padding:15px 0px">
                                视频信息
                            </div>
                            <div style="color:#000000;margin:10px 0px">
                                视频ID
                            </div>
                            <div style="color:#fff;">
                                {{ selshipin.id }}
                            </div>
                            <div style="color:#000000;margin:10px 0px">
                                原始文件名
                            </div>
                            <div style="color:#fff;">
                                {{ selshipin.file_name }}
                            </div>
                            <div style="color:#000000;margin:10px 0px">
                                视频大小
                            </div>
                            <div style="color:#fff;">
                                {{ (selshipin.file_size / 1024 / 1024).toFixed(2) }}MB
                            </div>
                            <div style="color:#000000;margin:10px 0px">
                                视频尺寸
                            </div>
                            <div style="color:#fff;">
                                {{ selshipin.width + '*' + selshipin.height }}
                            </div>
                            <div style="color:#000000;margin:10px 0px">
                                拍摄日期
                            </div>
                            <div style="color:#fff;">
                                {{ $moment(selshipin.file_time).format('lll') }}
                            </div>
                            <div
                                style="color:#000000;margin:10px 0px;display: flex;align-items: center;justify-content: center;">
                                <span style="margin-right: 10px;color:#777777">前台显示</span><el-switch
                                    style="margin-left: 5px;" v-model="selshipin.is_show" active-color="#ec652c"
                                    inactive-color="#cccccc" @change="gengxinshipinxinxi(selshipin, 1)" :active-value="1"
                                    :inactive-value="2" size="mini">
                                </el-switch>
                            </div>
                        </div>
                        <div>
                            <div>
                                <el-button size="mini" style="background: #cccccc;width:100px"
                                    @click="gengxinshipinxinxi(selshipin, 2)">置顶</el-button>
                                <el-button size="mini" style="background: #cccccc;width:100px"
                                    @click="downloadshipin(selshipin)" :loading="selshipin.loading">下载视频</el-button>
                            </div>

                        </div>
                    </div>

                </div>
            </el-dialog>
            <el-dialog class="spyldiv1" :close-on-click-modal="false" :visible.sync="tupianVisible" width="1200px"
                :show-close="false" :before-close="handleClose">
                <img src="../../assets/guanbi.svg"
                    style="position: absolute;right: 10px;top:10px;width:30px;cursor: pointer;" @click="handleClose" />
                <div :key="timetemp" style="display: flex;">
                    <div style="width:900px;height:600px;background:#999999;" class="ylspcla">
                        <el-carousel :loop="false" @change="qihuantupian" indicator-position="none"
                            :initial-index="tpinitialindex" :autoplay="false" arrow="always" style="height: 100%;">
                            <el-carousel-item v-for="(item, index) in photolist" :key="item.id"
                                style="height: 100%;display: flex;align-items: center;">
                                <img v-if="item['1600_path'] != null && tpinitialindex == index" :src="item['1600_path']"
                                    style="width: 100%;height: 100%;object-fit: contain;" />
                                <img v-if="item['1600_path'] == null && tpinitialindex == index"
                                    :src='IMAGEPATH + item.file_name'
                                    style="width: 100%;height: 100%;object-fit: contain;" />
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                    <div
                        style="width:300px;height:560px;background: #999999;border-left: 1px solid #cccccc;text-align: center;display: flex;flex-direction: column;justify-content: space-between;padding-bottom: 40px;">

                        <div>
                            <div
                                style="text-align: center;font-size:28px;color: #000000;border-bottom: 1px solid #cccccc;padding:15px 0px">
                                图片信息
                            </div>
                            <div style="color:#000000;margin:10px 0px">
                                图片ID
                            </div>
                            <div style="color:#fff;">
                                {{ seltupian.id }}
                            </div>
                            <div style="color:#000000;margin:10px 0px">
                                原始文件名
                            </div>
                            <div style="color:#fff;">
                                {{ seltupian.file_name }}
                            </div>
                            <div style="color:#000000;margin:10px 0px">
                                图片大小
                            </div>
                            <div style="color:#fff;">
                                {{ (seltupian.file_size / 1024 / 1024).toFixed(2) }}MB
                            </div>
                            <div style="color:#000000;margin:10px 0px">
                                图片尺寸
                            </div>
                            <div style="color:#fff;">
                                {{ seltupian.width + '*' + seltupian.height }}
                            </div>
                            <div style="color:#000000;margin:10px 0px">
                                拍摄日期
                            </div>
                            <div style="color:#fff;">
                                {{
                                    seltupian.file_time != null && seltupian.file_time != '' ?
                                    $moment(seltupian.file_time).format('lll') : '无' }}
                            </div>
                            <div
                                style="color:#000000;margin:10px 0px;display: flex;align-items: center;justify-content: center;">
                                <span style="margin-right: 10px;color:#777777">前台显示</span><el-switch
                                    style="margin-left: 5px;" v-model="seltupian.is_show" active-color="#ec652c"
                                    inactive-color="#cccccc" :active-value="1" :inactive-value="2" size="mini"
                                    @change="gengxintupianxinxi(seltupian, 1)">
                                </el-switch>
                            </div>
                            <div class="xtbqdiv"
                                style="color:#000000;margin:10px 0px;display: flex;align-items: center;justify-content: center;">
                                <el-select @change="gengxintupianxinxi(seltupian, 4)" size="mini"
                                    v-model="seltupian.share_label_id" multiple
                                    style="width:200px;margin-top: 10px;background: #fff;color: #000000;"
                                    placeholder="选择标签">
                                    <el-option v-for="item in biaoqianlist" :key="item.id" :label="item.labelname"
                                        :value="item.id + ''">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div>
                            <div>
                                <el-button size="mini" style="background: #cccccc;width:100px"
                                    @click="gengxintupianxinxi(seltupian, 2)">置顶</el-button>
                                <el-button size="mini" style="background: #cccccc;width:100px"
                                    @click="downloadImage(seltupian)">下载图片</el-button>
                            </div>
                            <div style="margin-top:10px;display: flex;justify-content: center;">
                                <danzhangtihuan :type="2" :tihuanitem="seltupian"
                                    :gengxintupianxinxi="gengxintupianxinxi" />
                                <el-button size="mini" style="background: #cccccc;width:100px "
                                    @click="gengxintupianxinxi(seltupian, 3)"
                                    v-show="seltupian.iscover != 1">设为封面</el-button>
                                <el-button size="mini" style="background: #cccccc;width:100px " :disabled="true"
                                    v-show="seltupian.iscover == 1">封面图</el-button>
                            </div>
                        </div>
                    </div>

                </div>
            </el-dialog>
            <el-dialog width="800px" :close-on-click-modal="false" :visible.sync="tihuanVisible" :show-close="false"
                :before-close="handleclosetihuan">
                <img src="../../assets/guanbi.svg"
                    style="position: absolute;right: 10px;top:10px;width:30px;cursor: pointer;"
                    @click="handleclosetihuan" />
                <div style="font-weight: 600;font-size: 16px;position: absolute;left: 20px;top:15px;color:#000000">
                    批量替换
                </div>
                <div :key="timetemp">
                    <piliangtihuan :allphotos="photolist" :collection_id="zuzhaoid" />
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import urlencode from "urlencode";
import fileDownload from 'js-file-download';
import { huodezuzhaoshipin, huodezuzhaotupian, huodezuzhaoxinxi, huodebiaoqian, gengxintupianxinxi, gengxinshipinxinxi } from "@/api/api";
import Danzhangtihuan from '@/components/Danzhangtihuan.vue';
import Piliangtihuan from '@/components/Piliangtihuan.vue';
export default {
    components: { Danzhangtihuan, Piliangtihuan },
    data() {
        return {
            secretkey: '',
            in_id: '',
            zuzhaoid: '',
            zuzhaotitle: '',
            zuzhaoobj: {},
            photolist: [],
            biaoqianlist: [],
            loading: false,
            currentpage: 1,
            pagesize: 50,
            showphotolist: [],
            total: 0,
            shipinlist: [],
            shipinloading: true,
            shipinVisible: false,
            selshipin: {},
            timetemp: new Date().getTime(),
            initialindex: 0,
            tpinitialindex: 0,
            scrdis: true,
            seltupian: {},
            tupianVisible: false,
            shipinyuanshilist: [],
            tihuanVisible: false
        }
    },
    props: {
        showfxlj: Function
    },
    created() {
        let query = this.$route.query
        console.log(query)
        this.secretkey = query.key
        this.huodezuzhaoxinxi(query.key)
document.title="后台|协作编辑图片"
    },
    methods: {

        async downloadshipin(item) {

            // 修改的文件名


            this.$set(item, 'loading', true)

            let playurl = item.play_url
            fetch(playurl)
                .then(response => response.blob())
                .then(blob => {
                    fileDownload(blob, item.file_name)
                    this.$set(item, 'loading', false)
                    // 下载并保存文件
                })
                .catch(error => {
                    console.error('下载视频失败:', error);
                });
            //添加下载记录

        },
        async downloadImage(item) {

            // 修改的文件名
            let imageUrl = item.original_path
            if (item.key != null) {
                imageUrl = this.IMAGEPATH + item.key
            }
            await fetch(imageUrl)
                .then(response => response.blob())
                .then(blob => {
                    fileDownload(blob, item.old_file_name); // 下载并保存文件
                })
                .catch(error => {
                    console.error('下载图片失败:', error);
                });
            //添加下载记录

        },

        async gengxinshipinxinxi(item, type) {
            if (type == 1) {
                await gengxinshipinxinxi({
                    id: item.id,
                    is_show: item.is_show,
                })
            }
            if (type == 2) {
                await gengxinshipinxinxi({
                    id: item.id,
                    create_time: this.$moment().format('YYYY-MM-DD HH:mm:ss')
                })
                let index = this.shipinlist.findIndex(ele => {
                    return item.id == ele.id
                })
                this.shipinlist.unshift(this.shipinlist.splice(index, 1)[0])
            }
        },
        async gengxintupianxinxi(item, type) {
            if (type == 1) {
                await gengxintupianxinxi({
                    id: item.id,
                    is_show: item.is_show,
                })
            }
            if (type == 2) {
                await gengxintupianxinxi({
                    id: item.id,
                    create_time: this.$moment().format('YYYY-MM-DD HH:mm:ss')
                })
                let index = this.showphotolist.findIndex(ele => {
                    return item.id == ele.id
                })
                this.showphotolist.unshift(this.showphotolist.splice(index, 1)[0])
            }
            if (type == 3) {
                await gengxintupianxinxi({
                    id: item.id,
                    setcover: 1
                })
                //  this.huodezuzhaoxinxi(this.secretkey)
                await huodezuzhaoxinxi({
                    secretkey: this.secretkey
                }).then(res => {
                    this.zuzhaoobj = res.data.data
                    this.showphotolist.forEach(ele => {
                        ele.iscover = 2

                    })
                    item.iscover = 1
                })



            }
            if (type == 4) {
                console.log(item)
                await gengxintupianxinxi({
                    id: item.id,
                    share_label_id: ',' + item.share_label_id.join(','),
                })
            }
        },
        async showshipinyulan(index) {
            //  item.paly_url = window.encodeURI(item.paly_url)
            if (this.shipinlist[0] != this.shipinyuanshilist[0]) {
                await huodezuzhaoshipin({ collection_id: this.zuzhaoid }).then(res => {
                    this.shipinyuanshilist = res.data.data
                })
            }
            this.initialindex = index
            this.selshipin = this.shipinlist[index]
            this.timetemp = new Date().getTime()
            this.shipinVisible = true

        },
        async showtupianyulan(index) {
            //  item.paly_url = window.encodeURI(item.paly_url)
            if (this.photolist[0] != this.showphotolist[0]) {
                await huodezuzhaotupian({ collection_id: this.zuzhaoid }).then(res => {
                    this.photolist = res.data.data
                })
            }

            this.tpinitialindex = index
            this.seltupian = this.photolist[index]
            this.timetemp = new Date().getTime()
            this.tupianVisible = true

        },
        qihuanshipin(index) {
            this.initialindex = index
            this.selshipin = this.shipinlist[index]
        },
        qihuantupian(index) {
            this.tpinitialindex = index
            this.seltupian = this.photolist[index]
        },
        async handleClose() {
            this.shipinVisible = false
            this.tupianVisible = false

            await huodezuzhaoshipin({ collection_id: this.zuzhaoid }).then(res => {
                this.shipinyuanshilist = res.data.data
            })
            await huodezuzhaotupian({ collection_id: this.zuzhaoid }).then(res => {
                this.photolist = res.data.data
            })
            this.timetemp = new Date().getTime()
        },
        handleclosetihuan() {
            this.tihuanVisible = false
            this.timetemp = new Date().getTime()
        },
        load() {
            console.log('1')
            if (this.showphotolist.length < this.photolist.length) {
                console.log('2')
                this.loading = true
                this.scrdis = false
                let start = (this.currentpage - 1) * this.pagesize
                let end = start + this.pagesize
                if (end >= this.total) {
                    end = this.total
                }
                setTimeout(() => {
                    for (let i = start; i < end; i++) {
                        this.showphotolist.push(this.photolist[i])
                    }
                    this.showphotolist.forEach(ele => {
                        if (!Array.isArray(ele.share_label_id)) {
                            let strsharelabelid = ele.share_label_id.slice(1)
                            if (strsharelabelid != '' && strsharelabelid != null) {
                                console.log(strsharelabelid)
                                ele.share_label_id = strsharelabelid.split(',')
                            } else {
                                ele.share_label_id = []
                            }
                        }
                        if (('https://resources.luchuaner.com/' + this.zuzhaoobj.cover_path) == ele['600_path']) {
                            ele.iscover = 1
                        }
                        if (ele.key != null && ('https://resources.luchuaner.com/' + this.zuzhaoobj.cover_path) == (this.IMAGEPATH + ele.key.slice(0, 15) + '_300small' + ele.key.slice(15))) {
                            ele.iscover = 1
                        }

                    })
                    this.currentpage = this.currentpage + 1
                    this.loading = false
                    this.scrdis = true

                }, 100)
                return true
            }
        },
        async huodezuzhaotupian() {
            await huodezuzhaotupian({ collection_id: this.zuzhaoid }).then(res => {
                this.photolist = res.data.data

                this.total = this.photolist.length
                this.load()
            })
        },
        async huodezuzhaoshipin() {
            await huodezuzhaoshipin({ collection_id: this.zuzhaoid }).then(res => {
                this.shipinlist = res.data.data
                // let shipinyuanshilist = [] 
                this.shipinlist.forEach(ele => {
                    this.shipinyuanshilist.push(ele)
                })
                // this.shipinlist.forEach(ele=>{
                //     ele.loading = false
                // })
                this.shipinloading = false
            })
        },
        fanhui() {
            window.history.back();
        },
        async huodebiaoqian() {
            await huodebiaoqian({
                collection_id: this.zuzhaoid,
            }).then(res => {
                this.biaoqianlist = res.data.data
            })
        },
        async huodezuzhaoxinxi(key) {
            await huodezuzhaoxinxi({
                secretkey: key
            }).then(res => {
                this.zuzhaoid = res.data.data.id
                this.zuzhaoobj = res.data.data
                console.log(this.zuzhaoid)
                this.zuzhaotitle = res.data.data.title
                this.in_id = res.data.data.in_id
                this.huodebiaoqian()
                this.huodezuzhaotupian()
                this.huodezuzhaoshipin()


            })
        },
    }
}
</script>

<style>
.swcla .el-switch__core {
    width: 30px !important;
    height: 15px !important;
}

.swcla .el-switch__core:after {
    content: "";
    position: absolute;
    top: 1px;
    left: 0px;
    border-radius: 100%;
    transition: all .3s;
    width: 12px;
    height: 12px;
    background-color: #FFF;


}

.swcla .el-switch.is-checked .el-switch__core::after {
    left: 100%;
    margin-left: -13px;
}

.ylspcla .el-carousel__container {
    position: relative;
    height: 600px;
}

.ylspcla .el-carousel__arrow {
    border: none;
    outline: 0;
    padding: 0;
    margin: 0;
    height: 80px;
    width: 40px;
    cursor: pointer;
    transition: .3s;
    border-radius: 0;
    background-color: rgba(255, 255, 255, .5);
    color: #FFF;
    position: absolute;
    top: 50%;
    z-index: 10;
    transform: translateY(-50%);
    text-align: center;
    font-size: 40px;

}

.ylspcla .el-carousel__arrow--right,
.el-notification.right {
    right: 0px;
}

.ylspcla .el-carousel__arrow--left,
.el-notification.left {
    left: 0px;
}

.spyldiv1 .el-dialog__header {
    padding: 0px;
}

.spyldiv1 .el-dialog__body {
    padding: 50px 00px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
    background: #cccccc;
}

.spyldiv1 .el-input__inner {
    background-color: #eeeeee;
    border-radius: 0px;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;
    display: inline-block;
    height: 30px;
    line-height: 30px;
    outline: 0;
    padding: 0 15px;
    transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
    width: 100%;
}

.spyldiv1 .el-input__inner::placeholder {
    color: #000;

}

.spyldiv1 .el-select .el-input .el-select__caret {
    color: #000;
}

.xtbqdiv .el-select__tags {
    height: 20px;
    overflow: auto;
}</style>